export default {
      id: "arrow-left-usage",
      viewBox: "0 0 31 33",
      url: __webpack_public_path__ + "svg/sprite.svg#arrow-left",
      toString: function () {
        return this.url;
      }
    }